import React from 'react';
import { useApp } from '../context/AppContext';
import { Clock } from 'lucide-react';

export default function Hero({ weekDishes = [], weekLabel = '', titleKey = 'hero_title' }) {
  const { t, tf } = useApp();
  const thumbs = weekDishes.slice(0, 3).map((d) => d.image);
  return (
    <section className="relative overflow-hidden bg-[#4b5e34] text-white">
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(circle at 20% 20%, #fff 1px, transparent 1px)', backgroundSize: '22px 22px' }} />
      <div className="relative max-w-[1280px] mx-auto px-5 py-14 md:py-16 grid md:grid-cols-2 gap-10 items-center">
        <div>
          <h1 className="font-display text-[44px] md:text-[56px] leading-[1.05] mb-3">{t(titleKey)}</h1>
          <p data-testid="hero-week-label" className="text-[#d8dcc6] text-lg mb-6">{weekLabel}</p>
          <ul className="space-y-2 max-w-lg">
            {weekDishes.slice(0, 10).map((d) => (
              <li key={d.id} className="flex gap-2.5 text-[#eef0e6] text-[15px]">
                <span className="mt-2 w-1.5 h-1.5 rounded-full bg-[#d9b06a] shrink-0" />
                <span>{tf(d.name)}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="hidden md:grid grid-cols-2 gap-4 justify-items-center">
          {thumbs.map((src, i) => (
            <div
              key={i}
              className={`w-40 h-40 lg:w-48 lg:h-48 overflow-hidden shadow-2xl ring-4 ring-white/10 ${i === 1 ? 'mt-10' : ''}`}
              style={{ transform: 'rotate(45deg)', borderRadius: 18 }}
            >
              <img src={src} alt="" className="w-full h-full object-cover" style={{ transform: 'rotate(-45deg) scale(1.5)' }} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
